// Unified Training Requests

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-training-details',
  templateUrl: './view-training-details.component.html',
  styleUrls: ['./view-training-details.component.scss']
})
export class ViewTrainingDetailsComponent {

  //training data
  @Input() data: string | any;


}
